/* eslint-disable prefer-named-capture-group, prefer-named-capture-group, no-useless-escape -- will need to test it later */
const emailRegex =
  /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;

/**
 * Validates email
 * @param {string} emailValue
 * @returns {?string} return string with the error or `undefined`
 */
const validateEmail = (emailValue) => {
  if (emailValue.length === 0) {
    return 'This field is required';
  }

  if (!emailRegex.test(emailValue)) {
    return 'Invalid email';
  }
};

/**
 * Validates email, returns localized message on error
 * @param {Object} intl - Internalization object from `useIntl`
 * @param {string} emailValue
 * @returns {?string} return localization object with the error message in case of an error
 */
const validateEmailWithLocalization = (intl, emailValue) => {
  if (emailValue.length === 0) {
    return intl.formatMessage({
      id: 'validation.email.empty',
      defaultMessage: 'Email is required',
      description: 'Error message shown after an attempt to submit a form with an empty email field',
    });
  }

  if (!emailRegex.test(emailValue)) {
    return intl.formatMessage({
      id: 'validation.email.invalid',
      defaultMessage: 'Invalid email address',
      description: 'Error message indicating that inputted value doesn’t match email address pattern',
    });
  }
};

/**
 * Validates string for being within the given length boundaries
 * @param {string} value
 * @param {number} [minLength]
 * @param {number} [maxLength]
 * @returns {?string} return string with the error or `undefined`
 */
const validateLength = (value, minLength, maxLength) => {
  if (value.length === 0) {
    return 'This field is required';
  }

  if (minLength && value.length < minLength) {
    return `Must be at least ${minLength} characters long`;
  }

  if (maxLength && value.length > maxLength) {
    return `Should not exceed ${maxLength} characters`;
  }

  return '';
};

/**
 * Validates string for being within the given length boundaries
 * @param {Object} intl - Internalization object from `useIntl`
 * @param {string} value
 * @param {number} [minLength]
 * @param {number} [maxLength]
 * @returns {?string} returns localized string on error
 */
const validateLengthWithLocalization = (intl, value, minLength, maxLength) => {
  if (value.length === 0) {
    return intl.formatMessage({
      id: 'validation.text.empty',
      defaultMessage: 'Field is required',
      description: 'Error message shown after an attempt to submit a form with an empty required field',
    });
  }

  if (value.length < minLength) {
    return intl.formatMessage(
      {
        id: 'validation.text.tooShort',
        defaultMessage: 'Must be at least {minLength, number} characters long',
        description:
          'Error message, shown when the minimum number of characters requirement for the field is not met, ' +
          'i.e. password must be at least 8 characters long',
      },
      { minLength },
    );
  }

  if (value.length > maxLength) {
    return intl.formatMessage(
      {
        id: 'validation.text.tooLong',
        defaultMessage: 'Should not exceed {maxLength, number} characters',
        description:
          'Error message, shown when the maximum number of characters requirement for the field is not met, ' +
          'i.e. password must not exceed 20 characters',
      },
      { maxLength },
    );
  }
};

export { validateEmail, validateEmailWithLocalization, validateLength, validateLengthWithLocalization };
